import React, { ReactNode, useState, useEffect } from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import "./index.css";

type Position = "Left" | "Center" | "right";
type Trigger = "click" | "hover" | "keyPress";

interface Props {
    id?: string,
    element?: React.ReactNode,
    position?: Position,
    trigger?: Trigger,
    hold?: boolean,
    maxHeight?: string,
    width?: string,
    onEnterClose?: boolean,
    disabled?: boolean,
    style?: React.CSSProperties,
    children: ReactNode,
    class?: string,
    visible?: boolean,
    setvisible?: Function,
    overflow?: boolean
}

const LcDropDown: React.FC<Props> = (props) => {
    const [visible, setVisible] = useState<boolean>(false);
    const [selected, setSelected] = useState<any>({});
    const [top, setTop] = useState<boolean>(false);

    useEffect(() => {
        if (props.visible) {
            setVisible(props.visible);
        }
    }, [props.visible])

    const handleClickAway = () => {
        setVisible(false);

        if (props.visible && props.setvisible) {
            props.setvisible(false);
        }
    };

    const handleEnterClose = () => setVisible(false);

    const handleClose = (e: any) => {
        setTop(window.innerHeight - e.clientY < 172 + 28);

        if (!visible) {
            if (!props.trigger || (props.trigger === "click" || props.trigger === undefined)) {
                setVisible(true);
            }
        }
        else {
            if (!props.hold && (!props.trigger || (props.trigger === "click" || props.trigger === "keyPress"))) {
                setVisible(false);
            }
        }
    }

    const handleChange = (event: any) => {
        if (props.trigger == "keyPress") {
            setSelected(event.target);
            setVisible(true);
        }
    }

    const handleKeyPress = (event: any) => {
        if (props.onEnterClose && event.key === "Enter") {
            handleEnterClose();
        }
    }

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div className={"lc-dropdown"}
                id={props.id}
                onClick={handleClose}
                onMouseOver={async (e) => {
                    setSelected(e.target);
                    (props.trigger === "hover") && setVisible(true);
                    //setSelected(e.target); (props.trigger === "hover" || props.trigger === "keyPress") && setVisible(true);
                }}
                onChange={(event) => handleChange(event)}
                onKeyPress={(event) => handleKeyPress(event)}
                style={props.style}
            >
                {props.element}
                {
                    !props.disabled && visible &&
                    <div className={`tooltipBody ${props.position ?? ""} ${(top) ? "top" : ""}`}>
                        {/* <h1>{props}</h1> */}
                        <div
                            className={`content scrollable-v ${props.class ?? ""}`}
                            style={{
                                maxHeight: props.maxHeight,
                                width: props.width,
                                overflow: (!props.overflow) ? "hidden" : "auto",
                                display: (props.visible !== undefined && !props.visible) ? "none" : ""
                            }}>
                            {props.children}
                        </div>
                    </div>
                }
            </div>
        </ClickAwayListener>
    );
}

//export const LcDropDown = React.memo(LcDropDownBase);
export default LcDropDown